import * as FormHelpers from './forms/helpers';
import { expandLauncher } from './driftrock_widget';

export function init(formContainer, config) {
  const sendButton = formContainer.querySelector('[data-form-chat-submit]');
  const chatInput = formContainer.querySelector('[data-form-chat-input]');
  const chatMessages = formContainer.querySelector('[data-form-chat-messages]');

  const state = {
    config: config,
    formContainer: formContainer,
    sendButton: sendButton,
    chatInput: chatInput,
    chatMessages: chatMessages,
    agentId: config.widget_options.agent_id,
    agentEnvironmentId: config.widget_options.agent_environment_id,
    sessionId: null,
  }

  window.Driftrock.chatConfig = state;

  sendButton.addEventListener('click', function (e) {
    sendMessage(state.chatInput.value);
  });
  chatInput.addEventListener('keypress', function (e) {
    if (e.key === 'Enter') {
      if (!state.sendButton.disabled) {
        sendMessage(state.chatInput.value);
      }
    }
  });

  const ctaTriggerButtons = document.querySelectorAll('[data-driftrock-chat-prompt-trigger]')
  ctaTriggerButtons.forEach(cta => {
    cta.addEventListener('click', function (e) {
      sendMessage(cta.dataset.driftrockChatPromptTrigger);
      expandLauncher(state.config);
    });
  });
}

function sendMessage(message) {
  const state = Driftrock.chatConfig;

  state.lastMessage = {
    from: 'user',
    text: message,
  }

  appendToMessages(state);
  sendToServer(state);
  addThinking(state);
  disableInputs(state);
}

function chipClickedCallback(e) {
  sendMessage(e.target.dataset.description);
}

function appendToMessages(state) {
  const messageContainer = document.createElement('div');
  if (state.lastMessage.type == 'chips') {
    messageContainer.classList.add("driftrock-aichat-chips");
  } else if (state.lastMessage.from == 'user') {
    messageContainer.classList.add("driftrock-aichat-bubble");
    messageContainer.classList.add("driftrock-aichat-bubble--right");
    state.chatInput.value = '';
  } else if (state.lastMessage.from == 'thinking') {
    messageContainer.classList.add("driftrock-aichat-bubble");
    messageContainer.classList.add("driftrock-aichat-bubble--left");
    messageContainer.setAttribute("style", `background-color: ${state.config.colour_scheme.background_colour}; color: ${state.config.colour_scheme.text_colour};`);
    messageContainer.classList.add("driftrock-aichat-bubble--thinking");
    messageContainer.classList.add("animate-flicker");
  } else if (state.lastMessage.from == 'server' && state.lastMessage.type == 'products') {
    messageContainer.classList.add("product-card--carousel");
  } else if (state.lastMessage.from == 'server') {
    messageContainer.classList.add("driftrock-aichat-bubble");
    messageContainer.classList.add("driftrock-aichat-bubble--left");
    messageContainer.setAttribute("style", `background-color: ${state.config.colour_scheme.background_colour}; color: ${state.config.colour_scheme.text_colour};`);
  }

  let chips = document.querySelectorAll(".driftrock-aichat-chips-chip");

  chips.forEach((chip) => {
    chip.removeEventListener("click", chipClickedCallback);
    chip.classList.remove("driftrock-aichat-chips-chip--enabled");
  });

  appendMessageContent(state, state.lastMessage, messageContainer)

  state.chatMessages.appendChild(messageContainer);
  state.chatMessages.scrollTop = state.chatMessages.scrollHeight;
}

function appendMessageContent(state, message, container) {
  if (message.type == "info") {
    const linkContainer = document.createElement('a')
    linkContainer.setAttribute('href', message.link)
    linkContainer.setAttribute('target', '_blank')
    linkContainer.classList.add("driftrock-aichat-link");

    const title = document.createElement('div');
    title.innerHTML = message.title
    title.classList.add("driftrock-aichat-link-title");

    const text = document.createElement('div');
    text.innerHTML = message.text

    linkContainer.appendChild(title);
    linkContainer.appendChild(text);
    container.appendChild(linkContainer)
  } else if (message.type == "image") {
    const image = document.createElement('img');
    image.src = message.src
    image.alt = message.text

    container.appendChild(image)
  } else if (message.type == "video" && message.embedded == "youtube") {
    const content = document.createElement('span');
    content.innerHTML = `<iframe id="ytplayer" type="text/html" width="100%" src="https://www.youtube.com/embed/${message.video_id}" allow="fullscreen;" frameborder="0"></iframe>`

    container.appendChild(content);
  } else if (message.type == "video") {
    const content = document.createElement('div');
    content.innerHTML = `<a class="link" href="https://www.youtube.com/watch?v=${message.video_id}" target="_blank">
      <img class="thumbnail" src="https://ytimg.googleusercontent.com/vi/${message.video_id}/hqdefault.jpg">
      </a>
      `;

    container.appendChild(content);
  } else if (message.type == "products") {
    message.options.forEach((product) => {
      const cardContainer = document.createElement('div')
      cardContainer.classList.add("product-card-container");

      const productCard = buildProductCard(state, product);
      cardContainer.appendChild(productCard);

      container.appendChild(cardContainer);
    });
  } else if (message.type == "custom") {
    message.submessages.forEach((submessage) => {
      appendMessageContent(state, submessage, container);
    });
  } else if (message.type == "chips") {
    message.options.forEach((optionMessage) => {
      const option = document.createElement('div');
      option.innerHTML = optionMessage.text
      option.dataset.description = optionMessage.description;
      option.classList.add("driftrock-aichat-chips-chip");
      option.classList.add("driftrock-aichat-chips-chip--enabled");

      if (optionMessage.action == "chat") {
        option.addEventListener("click", chipClickedCallback)
      } else if (optionMessage.action == "link") {
        option.addEventListener("click", function (e) {
          window.open(optionMessage.link, "_blank");
        })
      }

      container.appendChild(option);
    })
  } else {
    const content = document.createElement('span');
    content.innerHTML = message.text

    container.appendChild(content);
  }
}

function buildProductCard(state, message) {
  const content = document.createElement('div');
  content.classList.add("product-card");

  content.innerHTML = `
      <div class="product-card__image">
        <img alt="${message.title}" src="${message.src}">
      </div>
      <div class="product-card__name">${message.title}</div>
      <div class="product-card__description">${message.text}</div>
      `;

  var ctasChips = message.options.map((cta) => {
    const ctaChip = document.createElement('div');
    ctaChip.classList.add("product-card__cta");
    if (cta.link) {
      ctaChip.innerHTML = `<a class="product-card__cta_link" href="${cta.link}" target="_blank">${cta.text}</a>`;
    } else {
      ctaChip.innerHTML = `<a class="product-card__cta_link" href="#">${cta.text}</a>`;
      ctaChip.addEventListener("click", chipClickedCallback)
    }

    return ctaChip;
  })

  const ctasContainer = document.createElement('div');
  ctasContainer.classList.add("product-card__ctas");
  ctasChips.forEach((ctaChip) => { ctasContainer.appendChild(ctaChip) })

  content.appendChild(ctasContainer);
  return content;
}

function sendToServer(state) {
  return fetch(`${baseUrl()}/aichat?company_id=${state.config.company_id}`, {
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify({
      message: state.lastMessage.text,
      session_id: state.sessionId,
      agent_id: state.agentId,
      agent_environment_id: state.agentEnvironmentId,
    }),
  }).then(FormHelpers.handleApiError)
    .then(response => response.json())
    .then(data => handleServerResponse(state, data))
}

function handleServerResponse(state, data) {
  removeThinking(state);

  data.messages.forEach((message) => {
    state.lastMessage = {...message, from: 'server'} ;
    appendToMessages(state)
  })

  state.sessionId = data.session_id;
  enableInputs(state);
}

function disableInputs(state) {
  state.sendButton.disabled = true;
}

function enableInputs(state) {
  state.sendButton.disabled = false;
}

function addThinking(state) {
  state.lastMessage = { from: 'thinking', text: '...' };
  appendToMessages(state)
}

function removeThinking(state) {
  const thinkingMessages = state.chatMessages.querySelectorAll('.driftrock-aichat-bubble--thinking');

  thinkingMessages.forEach((thinkingMessage) => {
    thinkingMessage.remove();
  });
}

function baseUrl() {
  switch (Driftrock.settings.env) {
    case "development":
      return "http://inbound-leads:4020";
    case "staging":
      return "https://inbound-leads.stagingrock.com";
    default:
      return "https://inbound-leads.driftrock.com";
  }
}
